<template>
  <base-model :show="!!error" title="An error occurred" @close="handleError">
    <p>{{ error }}</p>
  </base-model>
  <base-model :show="isLoading" title="Loading..." fixed>
    <base-spinner></base-spinner>
  </base-model>
  <section>
    <br />
    <base-button @click="toogalTaskForm">Add New Task</base-button>
    <NewTask v-show="addTask" @new-task="NewTask" />
    <div class="taskList">
      <h2 v-if="tasks.length === 0">Task list is empty...</h2>
      <ul v-else>
        <TaskList
          v-for="task in tasks"
          :key="task.taskId"
          :id="task.taskId"
          :task="task.task"
          :description="task.description"
          :feedback="task.feedback"
          :mode="task.mode"
          :date="task.date"
          :tId="task.id"
          :assignTo="task.assignTo"
          @task-detail="taskDetail"
        />
      </ul>
    </div>
    <div class="taskDetail" v-if="!!details">
      <TaskDetail
        :id="details.taskId"
        :task="details.task"
        :date="details.date"
        :desc="details.description"
        :feeds="details.feedback"
        :mode="details.mode"
        :tId="details.id"
        :assignTo="details.assignTo"
      />
    </div>
  </section>
</template>

<script>
import TaskList from "../components/Task/TaskList.vue";
import TaskDetail from "../components/Task/TaskDetail.vue";
import NewTask from "../components/Task/NewTask.vue";
export default {
  props: ["projectId"],
  data() {
    return {
      details: null,
      addTask: false,
      error: null,
      isLoading: false,
    };
  },
  computed: {
    tasks() {
      return this.$store.getters["task/getTasks"].filter(
        (task) => task.taskId === this.projectId
      );
    },
  },
  created() {
    this.setTasks();
  },
  methods: {
    async setTasks() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("task/setTasks", this.projectId);
      } catch (err) {
        this.error = err.message || "Failed to load Task Try again";
      }
      this.isLoading = false;
    },
    taskDetail(id) {
      this.details = this.$store.getters["task/getTasks"].find(
        (task) => task.id === id
      );
    },
    NewTask(payload) {
      const taskData = {
        task: payload.task,
        description: payload.description,
        mode: payload.mode,
        projectId: this.projectId,
        assignTo: payload.assignTo,
      };
      this.$store.dispatch("task/addTask", taskData);
      this.addTask = false;
    },
    toogalTaskForm() {
      this.addTask = !this.addTask;
    },
    handleError() {
      this.error = null;
    },
  },
  components: {
    TaskDetail,
    TaskList,
    NewTask,
  },
};
</script>

<style scoped>
.box {
  margin-bottom: 15px;
  background: #f1f1f1;
}
.box label {
  width: 100%;
  float: left;
  margin-bottom: 10px;
  font-weight: bold;
}
.taskList {
  float: left;
  width: 58%;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #c1c1c1;
  margin: 25px 1%;
}
.taskList ul {
  margin: 0px;
  padding: 0px;
  width: 100%;
}
.taskDetail {
  float: left;
  width: 37%;
  margin: 25px 0px;
  margin-left: 2%;
  margin-right: 1%;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #c1c1c1;
}
</style>
